import { Nullable } from '@/scripts/models/utility-types';
import { BranchLinkOptions } from '../branchLinkConfiguration';

interface BranchSession {
  session_id: string;
  identity_id: string;
  link: string;
  data: string;
  browser_fingerprint_id: Nullable<string>;
  has_app: boolean;
}

const getBranchSession = (): Nullable<BranchSession> => {
  const session = sessionStorage && sessionStorage.getItem('branch_session');
  if (!session) {
    return null;
  }

  try {
    return JSON.parse(session);
  } catch (_e) {
    return null;
  }
};

const getBranchLink = (session: Nullable<BranchSession>): URL => {
  if (session && session.link) {
    return new URL(session.link);
  }

  // The absent of branch session indicate a likehood of adblock behaviour. In that case, manual domain reconstruction with a fallback branch domain will be used instead
  return new URL(window.ENVS.BRANCH_FALLBACK_DOMAIN || `https://app.vidds.ee/a/${window.ENVS.BRANCH_KEY}`);
};

export const generateBranchLongLink = (options: BranchLinkOptions): string => {
  const branchLink = getBranchLink(getBranchSession());

  const queryMap = {
    '~channel': options.channel,
    '~feature': options.feature,
    '~campaign': options.campaign,
    '~stage': options.stage,
    '~tags': options.tags,
    ...options.data,
  };

  Object
    .entries(queryMap)
    .forEach(([key, valueOrValues]): void => {
      const values = Array.isArray(valueOrValues) ? valueOrValues : [valueOrValues];
      values
        .filter(value => value !== undefined)
        .forEach((value) => {
          branchLink.searchParams.append(key, value as string);
        })
      ;
    })
  ;

  return branchLink.href;
};
